export default "__VITE_ASSET__CTuoWxH5__"